import { Component } from "react";
import classNames from "classnames";

// Components
import { EMintModalType, ETreatsAndRewardsPart } from "Components/Materials/MintModal";
import I18n from "Components/Elements/I18n";
import I18nStore from "Components/Elements/I18n/I18nStore";

// Assets
import { ReactComponent as TezosIcon } from "assets/images/icons/tezos.svg";
import PackImage1 from "assets/images/image35.png";
import PackImage2 from "assets/images/image38.png";
import PackImage3 from "assets/images/image47.png";

// Configs
import Config from "Configs/Config";

// Styles
import classes from "./classes.module.scss";

type Props = {
	setPart: ETreatsAndRewardsPart;
	isAvailable: boolean;
	onMintButtonClick: (mintModalType: EMintModalType) => void;
};
type IState = {};

export default class BuySemesterSet extends Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.onMintButtonClick = this.onMintButtonClick.bind(this);
	}

	override render() {
		const lng = I18nStore.getInstance().lang;

		return (
			<div className={classes["root"]} onClick={this.onMintButtonClick}>
				<div className={classes["set"]}>
					<div className={classes["images"]}>
						<img
							src={PackImage1}
							alt=""
							className={classNames(classes["image"], {
								[classes["blur"]!]: !this.props.isAvailable,
							})}
						/>
						<img
							src={PackImage2}
							alt=""
							className={classNames(classes["image"], {
								[classes["blur"]!]: !this.props.isAvailable,
							})}
						/>
						<img
							src={PackImage3}
							alt=""
							className={classNames(classes["image"], {
								[classes["blur"]!]: !this.props.isAvailable,
							})}
						/>
					</div>

					<p className={classNames(classes["text"], classes[lng])}>
						<I18n map="buy_sets.semester_set.mint" />
						&nbsp;
						<span className={classes["bold"]}>
							<I18n map={`treats_and_rewards.semester_set.${this.props.setPart}.title`} />
						</span>
						<br />
						<I18n map="buy_sets.semester_set.pictures" />
						&nbsp;
						<span className={classes["bold"]}>
							<I18n map="buy_sets.semester_set.rewards" />
						</span>
					</p>
				</div>

				<button
					className={classNames(classes["button"], {
						[classes["center"]!]: !this.props.isAvailable,
					})}>
					{!this.props.isAvailable ? (
						<I18n map="buy_sets.available_soon" />
					) : (
						<>
							<span>
								<I18n map="buy_sets.button" />
							</span>
							&nbsp;
							<span>
								{Config.getInstance().get().setsPrices.semesterSet} <TezosIcon className={classes["tezos-icon"]} />
							</span>
						</>
					)}
				</button>
			</div>
		);
	}

	private onMintButtonClick() {
		if (!this.props.isAvailable) return;
		this.props.onMintButtonClick(this.getMintType());
	}

	private getMintType() {
		switch (this.props.setPart) {
			case ETreatsAndRewardsPart.PART_ONE:
				return EMintModalType.SEMESTER_SET_1;
			case ETreatsAndRewardsPart.PART_TWO:
				return EMintModalType.SEMESTER_SET_2;
			default:
				return EMintModalType.SEMESTER_SET_1;
		}
	}
}
